import { PolicyDetails } from '../interfaces';

type PolicyReferences = PolicyDetails['references'];

/** One row of a policy sidebar "References" list, tagged with its source. */
export type PolicyReferenceRow =
  | (PolicyReferences['risks'][number] & { kind: 'risk' })
  | (PolicyReferences['procedures'][number] & { kind: 'procedure' });

const rowsCache = new WeakMap<PolicyReferences, PolicyReferenceRow[]>();

/**
 * Merges a policy's risk and procedure references (risks first) into a single
 * list, so one "Show more" toggle covers the whole References section.
 * Memoized per references object so template change detection gets a stable array.
 *
 * Bug 2857: sidebar lists are limited to 5 items with a "Show more" option.
 */
export function toPolicyReferenceRows(
  references: PolicyReferences | null | undefined,
): PolicyReferenceRow[] {
  if (!references) {
    return [];
  }
  let rows = rowsCache.get(references);
  if (!rows) {
    rows = [
      ...(references.risks ?? []).map((r) => ({ ...r, kind: 'risk' as const })),
      ...(references.procedures ?? []).map((p) => ({
        ...p,
        kind: 'procedure' as const,
      })),
    ];
    rowsCache.set(references, rows);
  }
  return rows;
}
